import type { PartialDeep } from 'type-fest';
import type { GetFeatureTogglesApiResponse } from '../../../src/store/facade/facadeApiV2';

export const generateFeatureTogglesMock = (): PartialDeep<GetFeatureTogglesApiResponse> => ({
    searchOptions: true,
    vehicleOptions: true,
    vehicleOutdoorTemperature: false,
    routeOptions: true,
    chargingOptions: true,
    switchEngineType: true,
    sendToVehicle: false,
    sendToOptimizer: false,
    deviceId: true,
    routeHandling: true,
});

export const generateFeatureTogglesAllActive = (): PartialDeep<GetFeatureTogglesApiResponse> => ({
    searchOptions: true,
    vehicleOptions: true,
    vehicleOutdoorTemperature: false,
    routeOptions: true,
    chargingOptions: true,
    switchEngineType: true,
    sendToVehicle: true,
    sendToOptimizer: true,
    deviceId: true,
    routeHandling: true,
});
